import { Component } from '@angular/core';
import { MenuItem } from '@layouts/menu/menu.model';
import Roles from '@shared/constants/roles';
import { AuthService } from '@core/auth/auth.service';
import * as _ from 'lodash-es';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  template: '<app-menu (menuClickEvent)="onClickEvent($event)" [selectedMenu]="selectedMenu"></app-menu>',
  styleUrls: ['./sidebar.component.scss']
})

/**
 * Sidebar Component
 */
export class SidebarComponent {
  selectedMenu: MenuItem;

  constructor(private authService: AuthService,
              private router: Router) {
  }

  onClickEvent(ev) {
    const roles = this.authService.getRolesByCompany() || [];
    if (!ev || !_.intersection(Roles.summaryView, roles).length) {
      this.selectedMenu = ev;
      return;
    }
    const { componentId } = ev;
    if (componentId === 'summary') {
      this.router.navigate(['/summary']);
    }
    this.selectedMenu = ev;
  }

}
